module.exports = __webpack_public_path__ + "img/notify_success.38c54a61.svg";